import React, { useEffect, useState } from "react";
import EditModal from "@core/modals/EditModal";
import EditButton from "@core/buttons/atoms/EditButton";
import Input from "@core/inputs/Input";
import { showError, showSuccess } from "@utils/helpers";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import StatisticalDivisionService from "@services/StatisticalDivisionService";
import SubAreaSelect from "@components/SubArea/partials/SubAreaSelect";

const EditStatisticalDivision = ({ statisticalDivision, onEdited }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [englishName, setEnglishName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedSubArea, setSelectedSubArea] = useState();
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    setShowModal(false);
    setName("");
    setEnglishName("");
    setDescription("");
    setSelectedSubArea();
  };

  useEffect(() => {
    if (showModal)
      StatisticalDivisionService.find(statisticalDivision.id).then(
        (response) => {
          setName(response.data.data.name);
          setEnglishName(response.data.data.name_eng);
          setDescription(response.data.data.description);
          setSelectedSubArea(response.data.data.sub_area?.id);
        }
      );
  }, [showModal, statisticalDivision.id]);

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    StatisticalDivisionService.update(
      statisticalDivision.id,
      name,
      englishName,
      description,
      selectedSubArea
    )
      .then(() => {
        showSuccess(t("statisticalDivisionEditedSuccessfully"));
        onEdited();
        closeModal();
      })
      .catch((err) => {
        showError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <PermissionHandler permission={"update_statistical_division"}>
      <EditButton onClick={() => setShowModal(true)} />
      <EditModal
        show={showModal}
        title={t("editStatisticalDivision")}
        onClose={closeModal}
        onSubmit={onSubmit}
        loading={loading}
        label={t("edit")}
      >
        <div className="mt-4 sm:mt-8 mb-2 grid grid-cols-2 gap-5 sm:gap-10">
          <Input
            height="h-10"
            label={t("name")}
            placeholder={t("name")}
            value={name}
            onChange={setName}
          />
          <Input
            height="h-10"
            label={t("nameEng")}
            placeholder={t("nameEng")}
            value={englishName}
            onChange={setEnglishName}
          />
          <Input
            height="h-10"
            label={t("description")}
            placeholder={t("description")}
            value={description}
            onChange={setDescription}
          />
          <div>
            <div className="text-xs font-semibold mb-2 flex">
              {t("subArea")}
              <div className="text-red-600 ml-1">*</div>
            </div>
            <SubAreaSelect
              openModal={showModal}
              onSelect={setSelectedSubArea}
              selected={selectedSubArea}
            />
          </div>
        </div>
      </EditModal>
    </PermissionHandler>
  );
};

export default EditStatisticalDivision;
